<template>
  <div class="aside__subblock">
    <div class="aside__list">
      <div class="aside__item -full-">
        <Input
          v-model="groupFolder.name"
          title="Название"
          placeholder="Название папки"
          :error="$v.$dirty && !$v.groupFolder.name.required"
          @input="compare"
        >
          <span v-if="$v.$dirty && !$v.groupFolder.name.required" class="form-item__error">
            Обязательное поле
          </span>
        </Input>
      </div>
      <div v-if="folders && !firstFolder" class="aside__item -full-">
        <SelectFolder
          v-model="groupFolder.parentId"
          class="aside__select -folder-select-"
          title="Выберите родительскую папку"
          :fields="folders"
          @input="compare"
        ></SelectFolder>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import SelectFolder from './SelectFolder';

export default {
  components: { SelectFolder },
  props: ['folders'],
  data: () => ({
    groupFolder: {},
    groupFolderBackup: {}
  }),
  computed: {
    ...mapState('usersGroups', {
      storeFolder: s => s.aside.data.folder,
      canSave: s => s.aside.meta.canSave
    }),
    firstFolder() {
      return (
        this.folders &&
        this.folders.find(item => item.folder.id === this.storeFolder.id) &&
        this.storeFolder.id !== undefined
      );
    }
  },
  beforeMount() {
    this.setData();
  },
  destroyed() {
    this.$store.dispatch('usersGroups/setAsideData', {
      path: 'folder',
      value: {}
    });
    this.$store.dispatch('usersGroups/setAsideData', {
      path: 'stagedFolder',
      value: {}
    });
    this.$store.dispatch('usersGroups/setAsideMeta', {
      path: 'canSave',
      value: false
    });
  },
  methods: {
    setData() {
      this.groupFolder = _.cloneDeep(this.storeFolder);
      this.groupFolderBackup = _.cloneDeep(this.groupFolder);
    },
    compare() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      const formHasChanges = !_.isEqual(this.groupFolder, this.groupFolderBackup);
      if (this.canSave !== formHasChanges) {
        this.$store.dispatch('usersGroups/setAsideMeta', {
          path: 'canSave',
          value: formHasChanges
        });
      }

      if (this.canSave) {
        this.$store.dispatch('usersGroups/setAsideData', {
          path: 'stagedFolder',
          value: this.groupFolder
        });
      }
    }
  },
  validations: {
    groupFolder: {
      name: { required }
    }
  }
};
</script>
